import {
	Box,
	Button,
	Card,
	CardContent,
	Chip,
	MenuItem,
	Select,
	Stack,
	Typography,
} from '@mui/material';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import React from 'react';

const PathChooseCard = (props) => {
	const card = props.card;
	const topics = props.topics;
	const subtopicsByTopic = props.subtopicsByTopic;
	const handleTopicChange = props.handleTopicChange;
	const handleSubtopicChange = props.handleSubtopicChange;
	const onSave = props.onSave;
	const index = props.index;
	const section = props.section;

	return (
		<Card
			sx={{
				display: 'flex',
				flexDirection: 'column',
				boxShadow: '0px 4px 16px rgb(0, 0, 0, 0.2)',
				minWidth: 350,
				maxWidth: 350,
			}}
			key={index}
		>
			<CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 1 }}>
				<Select
					value={card.topicId}
					onChange={(e) => handleTopicChange(card.id, e.target.value, section)}
					displayEmpty
					sx={{ mr: 2, textAlign: 'left' }}
				>
					<MenuItem value="">Select Topic</MenuItem>
					{topics.map((t) => (
						<MenuItem key={t.id} value={t.id}>
							{t.name}
						</MenuItem>
					))}
				</Select>

				{card.topicId && (
					<Select
						value={card.subtopicId}
						onChange={(e) => handleSubtopicChange(card.id, e.target.value, section)}
						displayEmpty
						sx={{ minWidth: 200, mr: 2, textAlign: 'left' }}
					>
						<MenuItem value="">Select Subtopic</MenuItem>
						{subtopicsByTopic[card.topicId]?.map((s) => (
							<MenuItem key={s.id} value={s.id}>
								{s.name}
							</MenuItem>
						))}
					</Select>
				)}
				<Button
					variant="contained"
					onClick={() => onSave(card.id, section)}
					disabled={!card.topicId || !card.subtopicId}
					sx={{ mt: 1 }}
				>
					Save
				</Button>
			</CardContent>
		</Card>
	);
};

export default PathChooseCard;
